module.exports = __webpack_public_path__ + "img/pagination.3011736e.svg";